// 保存搜索文本
export default function searchText(state = '', action) {
    switch (action.type) {
        case 'CHANGE_SEARCH_TEXT':
            return action.payload
        default:
            return state  
    }
}